import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { DirectivesModule } from '../../../../components/directives.module';
import { ListComponent } from './list.component';

const ROUTES: Routes = [
  {
    path: '',
    component: ListComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    MomentModule,
    RouterModule.forChild(ROUTES),
    MatDatepickerModule,
    AgGridAngular,
  ],
  declarations: [ListComponent],
  exports: [ListComponent],
})
export class ListReadyModule {}
